import React from "react";
import { useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";

const Loader = () => {
   const isLoading = useSelector((e) => e.globalAuth.value);
  return (
    <>
      {isLoading &&
      (
        <div className="loader-style container-fluid">
          <FadeLoader
            className="fade-loader"
            loading={true}
            color={"#132027"}
          />
        </div>
      )}
    </>
  );
};

export default Loader;
